import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus, Plug } from "lucide-react";
import { useConnectors } from "@/api/queries/connectors";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { ListTableShell } from "@/components/ResourceShell";
import { CreateConnectorDialog } from "@/components/connector-actions/CreateConnectorDialog";

export function ConnectorsList() {
  const { data, isLoading, isError, error, refetch } = useConnectors();
  const navigate = useNavigate();
  const [createOpen, setCreateOpen] = useState(false);
  const rows = data ?? [];

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between gap-4">
        <p className="text-[13px] text-text3">{rows.length} Connectors (Remote-MCP)</p>
        <Button onClick={() => setCreateOpen(true)} data-testid="action-create-connector">
          <Plus className="h-4 w-4" />
          Neuer Connector
        </Button>
      </div>

      <ListTableShell
        isLoading={isLoading && !data}
        isError={isError}
        errorMessage={(error as Error | undefined)?.message}
        isEmpty={!isLoading && rows.length === 0}
        emptyMessage="Noch keine Connectors"
        emptyHint="Klick 'Neuer Connector' zum Anlegen (z.B. Notion, Microsoft Learn)"
        onRetry={() => refetch()}
      >
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead>Auth</TableHead>
              <TableHead>Transport</TableHead>
              <TableHead>Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((c) => (
              <TableRow key={c.id} data-clickable="true" onClick={() => navigate(`/connectors/${c.id}`)}>
                <TableCell>
                  <div className="flex items-center gap-3">
                    <span className="grid h-8 w-8 shrink-0 place-items-center rounded-lg border border-border bg-surface2 text-text3">
                      <Plug className="h-4 w-4" />
                    </span>
                    <div>
                      <div className="font-semibold text-text">{c.name}</div>
                      <div className="mono truncate text-[11px] text-text3" title={c.url}>{c.url}</div>
                    </div>
                  </div>
                </TableCell>
                <TableCell><Badge variant={c.auth.kind === "none" ? "default" : "enrolled"}>{c.auth.kind}</Badge></TableCell>
                <TableCell><span className="text-[12.5px] text-text2">{c.transport}</span></TableCell>
                <TableCell>
                  {c.connection?.connected ? (
                    <span className="text-[12.5px] text-ok-text">● verbunden</span>
                  ) : (
                    <span className="text-[12.5px] text-text3">○ nicht verbunden</span>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </ListTableShell>

      {createOpen && (
        <CreateConnectorDialog open onOpenChange={setCreateOpen} onCreated={(id) => navigate(`/connectors/${id}`)} />
      )}
    </div>
  );
}
